import config from '../../../config/config';
import DefaultApiLimit from '../../../config/defaultLimit';
import {
  DeviceDetails,
  // DeviceDetailsEdit,
  DevicePointsRequestInterface,
} from '../../../interface/device-management-partner.interface';
import deleteRequest from '../base/delete';
import getRequest from '../base/get';
import patchRequest from '../base/patch';
import postRequest from '../base/post';
// import postStream from './base/postStream';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add device API
   * @param {any} data Device details to add
   */
  addDevice: (data: DeviceDetails): Promise<any> => {
    return postRequest(`${config.commonApiUrl}api/common/v1/charging-point`, data);
  },
  /**
   * Edit device API
   * @param {any} data Device details to edit
   * @param {any} id Device id
   * @param {any} isFileUpload - The isFileUpload
   */
  editDevice: (data: any, id: string, isFileUpload = false): Promise<any> => {
    return patchRequest(`${config.commonApiUrl}api/common/v1/charging-point/${id}`, data, isFileUpload);
  },
  /**
   * Edit device connect points status API
   * @param {any} data - Connectors data
   * @param {any} data.connectors - The connectors prop
   * @param {any} id - Device id
   * @returns {any} A promise that resolves with the update status
   */
  editDeviceConnectPointsStatus: (
    data: { connectors: DevicePointsRequestInterface[] },
    id: string,
  ): Promise<any> => {
    return patchRequest(`${config.commonApiUrl}api/common/v1/charging-point/connector/${id}`, data);
  },
  /**
   * Edit station status API
   * @param {any} id Device id
   * @param {any} data Status data
   */
  editAvailableStatusDevice: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/common/v1/charging-point/status/${id}`,
      data,
      false,
    );
  },
  /**
   * Reset device API
   * @param {any} data Reset data
   */
  resetDevice: (data: any): Promise<any> => {
    return postRequest(`${config.ocppApiUrl}api/ocpp16/v1/common/remote-reset-cp`, data);
  },
  /**
   * Fetch devices API
   * @param {any} query Query parameters
   */
  fetchDevices: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/common/v1/charging-point/`, {
      ...parameters,
    });
  },
  /**
   * Fetch device status count API
   * @param {any} query Query parameters
   * @returns {any} Device status count
   */
  fetchDeviceStatusCount: (query: QueryParameters = {}) => {
    return getRequest(
      `${config.commonApiUrl}api/common/v1/charging-point/chargerd-status-count`,
      { ...query },
    );
  },
  /**
   * Fetch devices API for export
   * @param {any} query Query parameters
   */
  fetchDevicesExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/common/v1/charging-point/export-data`, {
      ...parameters,
    });
  },
  /**
   * Fetch all device api
   * @param {any} stationId Station id
   */
  fetchAllDevicesList: (stationId: string | number) => {
    return getRequest(
      `${config.commonApiUrl}api/common/v1/charging-point/station/${stationId}`,
      {},
    );
  },
  /**
   * Fetch all device with details api
   * @param {any} stationId Station id
   */
  fetchAllDeviceDetailsList: (stationId: string | number) => {
    return getRequest(
      `${config.commonApiUrl}api/common/v1/charging-point/station/device-details/${stationId}`,
      {},
    );
  },
  /**
   * Fetch all device model api
   */
  fetchAllDeviceModels: () => {
    return getRequest(`${config.commonApiUrl}api/common/v1/charging-point/list-device-models`);
  },
  /**
   * Fetch all device api
   * @param {any} stationId Station id
   */
  fetchOneDevicePoints: (stationId: string | number) => {
    return getRequest(
      `${config.commonApiUrl}api/common/v1/charging-point/connector/${stationId}`,
      {},
    );
  },
  /**
   * Delete device API
   * @param {any} id Device id
   */
  deleteDevice: (id: string): Promise<any> => {
    return deleteRequest(`${config.commonApiUrl}api/common/v1/charging-point/${id}`);
  },
  /**
   * Fetch devices API
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/common/v1/charging-point/list-filters`);
  },
  /**
   * Get charging point details by Id
   * @param {any} id Charging point id
   */
  getChargingPointById: (id: string): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/common/v1/charging-point/${id}`);
  },
  /**
   * Fetching device image
   * @param {any} query Query parameters
   * @returns {any} Device image data
   */
  fetchDeviceImage: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(
      `${config.commonApiUrl}api/common/v1/charging-point-models/charge-point-metadata`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch all device vendors
   */
  fetchAllChargePointVendors: () => {
    return getRequest(`${config.commonApiUrl}api/common/v1/charging-point-models`);
  },
  /**
   * Fetch all charge point model
   * @param {any} chargePointVendor Charge point vendor
   */
  fetchAllChargePointModels: (chargePointVendor: string) => {
    return getRequest(
      `${config.commonApiUrl}api/common/v1/charging-point-models/${chargePointVendor}`,
    );
  },

  /**
   * Fetch subscriber connector limit
   */
  getSubscriptionConnecterLimit: () => {
    return getRequest(
      `${config.commonApiUrl}api/common/v1/charging-point/get-subscription-connecter-limit`,
    );
  },
  /**
   * charge Point List
   * @param {any} id - The id
   */
  fetchChargePointList: (id: string) => {
    return getRequest(
      `${config.commonApiUrl}api/common/v1/charging-point/charging-point-details/${id}`,
    );
  },
  /**
   * charge Point List
   * @param {any} id - The id
   */
  fetchChargingStationList: (id: string) => {
    return getRequest(`${config.commonApiUrl}api/common/v1/charging-station/station-list/${id}`);
  },
  /**
   * Mock fetch account name list API
   */
  fetchAccountNameList: () => {
    return getRequest(`${config.subscription.accountApiUrl}api/common/v1/account/account-names`);
  },
};
